import { createBrowserRouter, Navigate } from "react-router-dom";
import { RootLayout } from "./components/RootLayout";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { DashboardLayout } from "./components/DashboardLayout";
import { LandingPage } from "./pages/LandingPage";
import { LoginPage } from "./pages/LoginPage";
import { RegisterPage } from "./pages/RegisterPage";
import { DashboardPage } from "./pages/DashboardPage";
import { PropertiesPage } from "./pages/PropertiesPage";
import { AddPropertyPage } from "./pages/AddPropertyPage";
import { PropertyDetailPage } from "./pages/PropertyDetailPage";
import { PropertyAnalyticsPage } from "./pages/PropertyAnalyticsPage";
import { EditPropertyPage } from "./pages/EditPropertyPage";
import { AddUnitPage } from "./pages/AddUnitPage";
import { UnitDetailPage } from "./pages/UnitDetailPage";
import { AddTenantPage } from "./pages/AddTenantPage";
import { EditTenantPage } from "./pages/EditTenantPage";
import { AddExpensePage } from "./pages/AddExpensePage";
import { OfflinePage } from "./pages/OfflinePage";
import { JoinPage } from "./pages/JoinPage";
import { AuthCallbackPage } from "./pages/AuthCallbackPage";
import { TenantDashboardPage } from "./pages/TenantDashboardPage";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        index: true,
        element: <LandingPage />,
      },
      {
        path: "login",
        element: <LoginPage />,
      },
      {
        path: "register",
        element: <RegisterPage />,
      },
      {
        path: "offline",
        element: <OfflinePage />,
      },
      {
        path: "join/:token",
        element: <JoinPage />,
      },
      {
        path: "auth-callback",
        element: <AuthCallbackPage />,
      },
      {
        path: "tenant",
        element: <TenantDashboardPage />,
      },
      {
        element: <DashboardLayout />,
        children: [
          {
            path: "dashboard",
            element: <DashboardPage />,
          },
          {
            path: "properties",
            children: [
              {
                index: true,
                element: <PropertiesPage />,
              },
              {
                path: "new",
                element: <AddPropertyPage />,
              },
            ],
          },
          {
            path: "property/:id",
            children: [
              {
                index: true,
                element: <PropertyDetailPage />,
              },
              {
                path: "analytics",
                element: <PropertyAnalyticsPage />,
              },
              {
                path: "edit",
                element: <EditPropertyPage />,
              },
              {
                path: "units/new",
                element: <AddUnitPage />,
              },
              {
                path: "unit/:unitId",
                element: <UnitDetailPage />,
              },
              {
                path: "unit/:unitId/tenant/:tenantId/edit",
                element: <EditTenantPage />,
              },
              {
                path: "tenants/new",
                element: <AddTenantPage />,
              },
              {
                path: "expenses/new",
                element: <AddExpensePage />,
              },
            ],
          },
        ],
      },
      {
        path: "*",
        element: <Navigate to="/" replace />,
      },
    ],
  },
]);
